import Modals from '../../Modals';
import classes from './SignInErrorModal.module.css'
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { LanguageContext } from '../../../../context/LanguageContext';
import SignInSettings from '../../auth/SignInSettings';

const SignInErrorModal = (props) => {
  const authToken = Cookies.get('auth_token');
  const { showErrorModal, onHide, setShowErrorModal, country, showSignIn, setShowSignIn } = props;
  const [token, setToken] = useState(authToken);
  const [localShow, setLocalShow] = useState(false);

  const show = showSignIn !== undefined ? showSignIn : localShow;
  const setShow = setShowSignIn !== undefined ? setShowSignIn : setLocalShow;

  const tokenHandler = (userToken) => {
    !token && setToken(userToken);
  };

  const handleLoginClick = () => {
    setShowErrorModal();
    setTimeout(() => {
      setShow(true);
    }, 400);
  };

  const modalHideHandler = () => {
    onHide();
    setShow(false);
  };

  return (
    <LanguageContext.Consumer>
      {(ctx) => (
        <>
          <Modals show={showErrorModal} onHide={onHide}>
            <div className='px-3'>
              <div className='d-flex align-items-center justify-content-center'>
                <img
                  src='../../assets/icons/error/signInError.svg'
                  alt='error'
                  className={classes.width_40_percent}
                />
              </div>
              <div className={`mt-4 text-center ${classes.font_size_25} ${classes.color_black} ${classes.font_weight_600} ${classes.sign_in} text-center`}>
                <span>{ctx.data?.please[ctx.language]}</span>
                <span
                  className={`${classes.sign_in_span}`}
                  onClick={handleLoginClick}
                >
                  {ctx.data?.login[ctx.language]}
                </span>
                <span>{ctx.data?.get_access[ctx.language]}</span>
              </div>
            </div>
          </Modals>

          <SignInSettings
            country={country}
            showAuth={show}
            setShowAuth={setShow}
            onHide={modalHideHandler}
            onPress={() => {}}
            setUserData={() => setShow(false)}
            setShow={setShow}
            setCookiesToken={tokenHandler}
          />
        </>
      )}
    </LanguageContext.Consumer>
  );
};

export default SignInErrorModal;